export default "__VITE_PUBLIC_ASSET__2b72b560__"